/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamLangTranslationQuestionViewModel } from "../types/BotExamLangTranslationQuestionViewModel.ts";
import { botExamLangTranslationOptionViewModelSchema } from "./botExamLangTranslationOptionViewModelSchema.ts";

export const botExamLangTranslationQuestionViewModelSchema = z.object({
  questionId: z.optional(z.number().int().describe("ID da questão traduzida.")),
  classroomDisciplineBotExamLangId: z.optional(
    z
      .number()
      .int()
      .describe("ID do idioma da prova bot ao qual a questão pertence."),
  ),
  isReviewed: z.optional(
    z.boolean().describe("Indica se a questão traduzida já foi revisada."),
  ),
  type: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo da questão. Enum EBotExamType: `1` = Default, `2` = TrueFalse, `3` = MultipleAffirmations, `4` = FillInTheBlanks.",
      ),
  ),
  originalLabel: z
    .string()
    .describe(
      "Enunciado original da questão gerado pelo bot (pt-BR). Opcional.",
    )
    .nullish(),
  originalExplanation: z
    .string()
    .describe("Explicação original da resposta correta (pt-BR). Opcional.")
    .nullish(),
  originalTranscriptExcerpt: z
    .string()
    .describe(
      "Trecho da transcrição original (pt-BR) que embasou a questão. Opcional.",
    )
    .nullish(),
  label: z
    .string()
    .describe("Enunciado da questão traduzido para o idioma alvo. Opcional.")
    .nullish(),
  explanation: z
    .string()
    .describe(
      "Explicação da resposta correta traduzida para o idioma alvo. Opcional.",
    )
    .nullish(),
  transcriptExcerpt: z
    .string()
    .describe("Trecho da transcrição traduzido para o idioma alvo. Opcional.")
    .nullish(),
  options: z
    .array(z.lazy(() => botExamLangTranslationOptionViewModelSchema))
    .describe("Lista de alternativas da questão.")
    .nullish(),
}) as unknown as ToZod<BotExamLangTranslationQuestionViewModel>;
